var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hots-page"},[_c('div',{staticClass:"render-content"},[_c('set-hots',{attrs:{"camera-item":_vm.activeCamera}})],1),_c('bottom-scene-list',{on:{"updateCamera":_vm.updateCamera}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }